module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-93b74a363852e3763a074de1d1fae9a3.png";